import { useDispatch, useSelector } from "react-redux";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useState } from "react";
import {
  useGetAiSettingsListDataQuery,
  useUpdateAisettingsTableHeadDataMutation,
} from "../../../store/queries/CMS";
import { getFormatedDate } from "../../../utils/Functions/table";
import { toast } from "react-toastify";
import { viewApiSettings } from "./api";

const useAiSettings = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const dispatch = useDispatch();
  const { showEditModal } = useSelector((state) => state.global);
  const [aiSettingsState, setAiSettingsState] = useState({
    currentPageSize: 10,
    currentPage: 1,
    search: "",
    sortBy: "",
    sortOrder: "desc",
    CardOfferExcelSendModal: false,
    uploadImageModal: false,
    itemId: "",
    showModal: false,
    itemData: "",
    tableFeilds: {},
  });
  const {
    data: aiSettingsList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetAiSettingsListDataQuery({
    page_size: aiSettingsState?.currentPageSize,
    page: aiSettingsState?.currentPage,
    search: aiSettingsState?.search,
    sort_by: aiSettingsState?.sortBy,
    sort_order: aiSettingsState?.sortOrder,
  });
  const [updateAisettingsTableHeadData] =
    useUpdateAisettingsTableHeadDataMutation();
  const handleSearch = (e) => {
    setAiSettingsState((prev) => ({
      ...prev,
      search: e?.target?.value,
      currentPage: 1,
    }));
  };
  const handleClearClick = () => {
    setAiSettingsState((prev) => ({
      ...prev,
      search: "",
      currentPage: 1,
    }));
  };
  const handleSort = (label) => {
    if (aiSettingsState?.sortBy === label) {
      setAiSettingsState((prev) => ({
        ...prev,
        currentPage: 1,
        sortOrder: prev.sortOrder === "asc" ? "desc" : "asc",
      }));
    } else {
      setAiSettingsState((prev) => ({
        ...prev,
        currentPage: 1,
        sortBy: label,
        sortOrder: "asc",
      }));
    }
  };
  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };
  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data?.[field]}</p>,
      status: (field, data) =>
        data?.status === 1 ? (
          <span className={"pro-badge badge-primary-outline"}>{"Active"}</span>
        ) : data?.status === 2 ? (
          <span className={"pro-badge badge-danger-outline"}>{"InActive"}</span>
        ) : (
          data?.status
        ),
      user_mobiles: (field, data) => (
        <p className="pro-mb-0">
          {data?.[field]?.map((num, i) => (
            <span key={i}>
              {num}
              {i !== data[field].length - 1 ? ", " : ""}
            </span>
          ))}
        </p>
      ),
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };
  const handleEditAction = (id) => {
    const itemId = id?.[0];
    viewApiSettings(itemId).then((res) => {
      if (res?.data?.status_code === 200) {
        setAiSettingsState((prev) => ({
          ...prev,
          itemId: itemId,
          itemData: res?.data?.data,
          showModal: true,
        }));
      } else {
        toast.error("Something went wrong");
      }
    });
  };
  const handlePagination = (page) => {
    setAiSettingsState((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };
  const handlePageSize = ({ value: page_size }) => {
    setAiSettingsState((prev) => ({
      ...prev,
      currentPageSize: page_size,
      currentPage: 1,
    }));
  };
  const closeModal = () => {
    setAiSettingsState((prev) => ({
      ...prev,
      imageData: "",
      showModal: false,
    }));
  };
  return {
    isLoading,
    isFetching,
    showEditModal,
    paginationOptions,
    aiSettingsList,
    aiSettingsState,
    handleEditAction,
    closeModal,
    setAiSettingsState,
    updateAisettingsTableHeadData,
    handleEditColumnsClick,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  };
};

export default useAiSettings;
